import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { registerEvent } from '../utils/google-analytics.js';
import { LoadOrganization } from '../utils/queries.js';
import { buildShareTitle } from '../utils/shareUtils.js';
import FacebookShareButton from './FacebookShareButton.jsx';
import LinkedinFeedButton from './LinkedinFeedButton.jsx';
import LinkedinProfileButton from './LinkedinProfileButton.jsx';
import TwitterShareButton from './TwitterShareButton.jsx';
import WhatsappShareButton from './WhatsappShareButton.jsx';
import MoreIcon from './icons/MoreIcon.jsx';
import ShareDialog from './ui/ShareDialog.jsx';
import { border } from '../utils/theme.js';
import Box from '@mui/material/Box';

export default function CertificateShare({ certificate, validated }) {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);
    const organization = LoadOrganization(certificate.minter).data;
    const sharePostTitle = buildShareTitle(certificate, organization, t);
    const sendEvent = (method) => registerEvent(`share-${method}`);

    return (
        <>
            <Box
                sx={{
                    ...border,
                    borderRadius: 4,
                    paddingX: 2,
                    paddingY: { xs: 1, md: 2 },
                }}
            >
                <Stack>
                    <Typography variant="subtitle1">{t('certificate.share.title')}</Typography>
                    <Typography variant="body2" pb={2}>
                        {t(validated ? 'certificate.share.subtitle_enabled' : 'certificate.share.subtitle_disabled')}
                    </Typography>
                    <LinkedinProfileButton
                        organization={organization}
                        onSendEvent={sendEvent}
                        disabled={!validated}
                        cert={certificate}
                    />
                    <Typography variant="body2" pt={2}>
                        {t('certificate.share.share_on')}
                    </Typography>
                    <Stack pt={1} direction={'row'} spacing={{ md: 2, xs: 1 }}>
                        <LinkedinFeedButton onSendEvent={sendEvent} cert={certificate} disabled={!validated} />
                        <TwitterShareButton
                            sharePostTitle={sharePostTitle}
                            onSendEvent={sendEvent}
                            validated={validated}
                            certificate={certificate}
                        />
                        <FacebookShareButton onSendEvent={sendEvent} validated={validated} certificate={certificate} />

                        <WhatsappShareButton
                            onSendEvent={sendEvent}
                            validated={validated}
                            sharePostTitle={sharePostTitle}
                            certificate={certificate}
                        />

                        <span
                            style={{ cursor: validated ? 'pointer' : 'auto' }}
                            onClick={() => (validated ? setOpen(true) : null)}
                        >
                            <MoreIcon fill={validated ? '#5124A6' : '#CCC9D1'} />
                        </span>
                    </Stack>
                </Stack>
            </Box>
            {open && (
                <ShareDialog
                    onClose={() => setOpen(false)}
                    open={open}
                    onSendEvent={sendEvent}
                    certificate={certificate}
                    validated={validated}
                    sharePostTitle={sharePostTitle}
                />
            )}
        </>
    );
}
